import { CalendarDate, Day } from "@gemma/dates";
import { DateRelativeTo, EntryPeriod } from "@gemma/utils";

import { Timesheet } from "@timesheets/constants-common";
import { getTimesheetDisabledDates } from "./getTimesheetDisabledDates";

export function timesheetOpenDate() {
  return {
    computed: {
      timesheetOpenDate(
        //
        //
        this: {
          contractor?: {
            timesheetEntries?: { entryDate: Readonly<CalendarDate>; currentStatusChange?: { status: Timesheet.Statuses } }[];
            entryPeriod: EntryPeriod;
            start?: Readonly<CalendarDate>;
            end?: Readonly<CalendarDate>;
          };
          recruitmentAgencySettings: {
            defaults: {
              dateRelativeTo: DateRelativeTo;
              timesheetWeekStartsOn: Day;
            };
          };
        }
      ) {
        if (this.contractor && this.contractor.timesheetEntries) {
          let mostRecentActiveTimesheetItemDate = CalendarDate.Earliest;
          if (this.contractor.timesheetEntries.length > 0) {
            this.contractor.timesheetEntries
              .filter(timesheetItem => timesheetItem.currentStatusChange && timesheetItem.currentStatusChange.status !== Timesheet.Statuses.Deleted)
              .forEach(timesheetItem => {
                const entryDate = CalendarDate.parse(timesheetItem.entryDate);
                if (entryDate && entryDate.isAfter(mostRecentActiveTimesheetItemDate)) {
                  mostRecentActiveTimesheetItemDate = entryDate;
                }
              });
          }

          if (mostRecentActiveTimesheetItemDate) {
            const date = mostRecentActiveTimesheetItemDate.asDate;

            return date;
          } else {
            const today = CalendarDate.Today;
            const timesheetDisabledDates = getTimesheetDisabledDates.call(this, this.contractor);
            if (timesheetDisabledDates.from) {
              if (today.isAfter(timesheetDisabledDates.from)) {
                const date = timesheetDisabledDates.to;
                return date;
              }
            }

            return today.asDate;
          }
        }
      },
    },
  };
}
